export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.visits-report.index`,
        path: `/${prefix}/${pre}/visits-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.visits-report.index`,
                PageDescription: "Patient Reports: Visits report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.visits-report.index`,
        path: `/${prefix}/${pre}/visits-report/print`,
        component: () => import('./prints/VisitReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.visits-report.index`,
                PageDescription: "Patient Reports: Visits report",
            },
            print: true,
        },
    },
];